import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Empty } from 'antd';
import UIComponent from './uiComponent';
function UIPlaceholderComponent(props) {
    return (_jsx(Empty, { description: _jsxs("div", { children: [_jsx("p", { children: props.text }), _jsx("span", { children: _jsx("a", { href: props.url, children: "link" }) })] }) }));
}
export default class UIPlaceholder extends UIComponent {
    text;
    url;
    constructor(s) {
        super(s);
        this.text = this.getProperty('text');
        this.url = this.getProperty('url');
    }
    getComponent() {
        const props = { url: this.url, text: this.text };
        return _jsx(UIPlaceholderComponent, { ...props });
    }
}
//# sourceMappingURL=uiPlaceholder.js.map